import { render, staticRenderFns } from "./FollowUnfollow.vue?vue&type=template&id=493a959c&scoped=true"
import script from "./FollowUnfollow.vue?vue&type=script&lang=js"
export * from "./FollowUnfollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a959c",
  null
  
)

export default component.exports